<div class="card shadow">
	<div class="card-body m-3">
        <p class="lead font-weight-bold" *ngIf="code">Uitslag <em>{{code}}</em></p>
        
        <h1 class="font-weight-bold">Favoriete partij van alle stemmers <small>({{numberWithCommas(score)}} van de {{numberWithCommas(total)}})</small></h1>
		<div class="bg-light p-3">
			<h2 class="font-weight-bold text-center">{{politicParty['name']}}</h2>
			<p><img [src]="'./assets/partijen/'+politicParty.logo+''" class="float-left mr-2" alt="{{politicParty.name}}"> {{politicParty.description}}</p><p><em><a href="{{politicParty.url}}">Lees meer over {{politicParty['name']}} op Methode M.</a></em></p>
		</div>
		
		<h3 class="font-weight-bold mt-4">Politieke richting</h3>
		<div class="row" id="politicalDirection">
			<div class="col-6">        
	  			<canvas baseChart
					[data]="wingChartData"
					[options]="directionChartOptions"
					[colors]="directionChartColors"
					[labels]="wingChartLabels"
					[chartType]="wingChartType">
	  			</canvas>
			</div>
			<div class="col-6">
	  			<canvas baseChart
					[data]="directionChartData"
					[options]="directionChartOptions"
					[labels]="directionChartLabels"
					[colors]="wingChartColors"
					[chartType]="directionChartType">
	  			</canvas>
			</div>
		</div>	
		
        <h3 class="font-weight-bold mt-4">Scores per partij</h3>
		<div>
		  <div>
			<div style="display: block">
			  <canvas baseChart
				[datasets]="barChartData"
				[labels]="barChartLabels"
				[options]="barChartOptions"
				[plugins]="barChartPlugins"
				[legend]="barChartLegend"
				[chartType]="barChartType">
			  </canvas>
			</div>
		  </div>
		</div>
		
		<h3 class="font-weight-bold mt-4">Reactie op de uitslag?</h3>
		<div class="reaction-table">
			<div class="reaction-y"><span>100%</span></div>
			<div class="reaction-y"><span>90%</span></div>
			<div class="reaction-y"><span>80%</span></div>
			<div class="reaction-y"><span>70%</span></div>
			<div class="reaction-y"><span>60%</span></div>
			<div class="reaction-y"><span>50%</span></div>
			<div class="reaction-y"><span>40%</span></div>
			<div class="reaction-y"><span>30%</span></div>
			<div class="reaction-y"><span>20%</span></div>
			<div class="reaction-y"><span>10%</span></div>
			<div class="reaction-y"><span>0%</span></div>
			<div class="reaction-x">
				<div class="row">
					<div class="col-2">
						<span class="grid"></span>
						<span class="bar">
							<span class="fill" [style.height]="reactionScorePercentage['Boos'] + '%'">
								<span class="reaction-result-perc" *ngIf="reactionScorePercentage['Boos'] > 0">{{reactionScorePercentage['Boos']}}%</span>
								<img src="./assets/emojis/angry-face.gif" class="mt-1" alt="Boos"/>
							</span>
						</span>
						<span class="label">Boos</span>
					</div>
					<div class="col-2">
						<span class="grid"></span>
						<span class="bar">
							<span class="fill" [style.height]="reactionScorePercentage['Verbluft'] + '%'">
								<span class="reaction-result-perc" *ngIf="reactionScorePercentage['Verbluft'] > 0">{{reactionScorePercentage['Verbluft']}}%</span>
								<img src="./assets/emojis/astonished.gif" class="mt-1" alt="Verrast"/>
							</span>
						</span>
						<span class="label">Verbluft</span>
					</div>
					<div class="col-2">
						<span class="grid"></span>
						<span class="bar">
							<span class="fill" [style.height]="reactionScorePercentage['Geweldig'] + '%'">
								<span class="reaction-result-perc" *ngIf="reactionScorePercentage['Geweldig'] > 0">{{reactionScorePercentage['Geweldig']}}%</span>
								<img src="./assets/emojis/beating-heart.gif" class="mt-1" alt="Geweldig"/>
							</span>
						</span>
						<span class="label">Geweldig</span>
					</div>
					<div class="col-2">
						<span class="grid"></span>
						<span class="bar">
							<span class="fill" [style.height]="reactionScorePercentage['Huilen'] + '%'">
								<span class="reaction-result-perc" *ngIf="reactionScorePercentage['Huilen'] > 0">{{reactionScorePercentage['Huilen']}}%</span>
								<img src="./assets/emojis/crying-face.gif" class="mt-1" alt="Huilen"/>
							</span>
						</span>
						<span class="label">Huilen</span>
					</div>
					<div class="col-2">
						<span class="grid"></span>
						<span class="bar">
							<span class="fill" [style.height]="reactionScorePercentage['Blij'] + '%'">
								<span class="reaction-result-perc" *ngIf="reactionScorePercentage['Blij'] > 0">{{reactionScorePercentage['Blij']}}%</span>
								<img src="./assets/emojis/beaming-face.gif" class="mt-1" alt="Blij"/>
							</span>
						</span>
						<span class="label">Blij</span>
					</div>
					<div class="col-2">
						<span class="grid"></span>
						<span class="bar">
							<span class="fill" [style.height]="reactionScorePercentage['Leuk'] + '%'">
								<span class="reaction-result-perc" *ngIf="reactionScorePercentage['Leuk'] > 0">{{reactionScorePercentage['Leuk']}}%</span>
								<img src="./assets/emojis/thumbs-up-sign.gif" class="mr-2 mt-1" alt="Leuk"/>
							</span>
						</span>
						<span class="label">Leuk</span>
					</div>
				</div>
			</div>
		</div>
		

    </div>
    <div class="text-center my-2 mb-5">         
        <a href="./start/{{code}}" class="btn btn-success font-weight-bold text-decoration-none">Doe de stemwijzer <span *ngIf="code">met <em>{{code}}</em></span> opnieuw</a>
    </div>
</div>
